import React from "react";
import { Badge } from "react-bootstrap";
import { BsChevronLeft, BsCircle, BsCircleFill, BsCpu, BsDatabase, BsLaptop, BsServer, BsSquare, BsWindowDesktop } from "react-icons/bs";
import { GrServerCluster } from "react-icons/gr";

const Solutions = () => {
  const services = [
    {
      title: "داده",
      icon:<BsDatabase size={"45px"}/>,
      description: "خدمات مشاوره‌ای ما در حوزه داده، به کسب‌وکارها کمک می‌کند تا از داده‌هایشان به عنوان دارایی استراتژیک استفاده کنند.",
      items: [
        "مدیریت و پاکسازی داده‌ها: ارزیابی کیفیت داده‌ها و پیشنهاد راهکارهای پاکسازی و استانداردسازی.",
        "تحلیل داده و گزارش‌گیری پیشرفته: طراحی داشبوردها و تحلیل‌های پیشرفته برای کشف فرصت‌ها.",
        "طراحی و بهینه‌سازی پایگاه داده‌ها: ساختاردهی و بهینه‌سازی پایگاه‌های داده سازمانی.",
        "یکپارچه‌سازی داده‌ها و ETL: انتقال، ادغام و همگام‌سازی داده‌ها بین سیستم‌ها.",
        "امنیت و حاکمیت داده‌ها: تدوین سیاست‌ها و استانداردهای امنیت و مدیریت دسترسی داده‌ها."
      ]
    },
    {
      title: "هوش مصنوعی",
      icon:<BsCpu size={"45px"}/>,
      description: "با خدمات مشاوره‌ای ما، کسب‌وکارها می‌توانند هوش مصنوعی را به ابزار عملیاتی تبدیل کنند.",
      items: [
        "مدل‌سازی و پیاده‌سازی AI: ارزیابی نیازها و طراحی راهکارهای AI متناسب با کسب‌وکار.",
        "یادگیری ماشین و پیش‌بینی رفتار: توسعه مدل‌های پیش‌بینی و تحلیل رفتار مشتریان و فرآیندها.",
        "پردازش زبان طبیعی و چت‌بات‌ها: طراحی سیستم‌های مکالمه هوشمند و تجزیه و تحلیل متن.",
        "بینایی ماشین و پردازش تصویر: ارائه راهکارهای تصویری و بینایی ماشین برای بهبود عملیات.",
        "ارزیابی و بهینه‌سازی مدل‌های AI: بررسی عملکرد مدل‌ها و ارائه توصیه برای بهینه‌سازی."
      ]
    },
    {
      title: "نرم افزار",
      icon:<BsLaptop size={"45px"}/>,
      description: "مشاوره ما به سازمان‌ها کمک می‌کند تا نرم‌افزارها را بهینه و مطابق نیاز واقعی پیاده‌سازی کنند.",
      items: [
        "توسعه نرم‌افزار سفارشی: ارائه استراتژی توسعه نرم‌افزار متناسب با فرآیندهای سازمان.",
        "انتخاب و پیاده‌سازی ابزارهای نرم‌افزاری: مشاوره برای انتخاب بهترین ابزارها و فناوری‌ها.",
        "معماری و طراحی نرم‌افزار: ارائه راهکار در طراحی ساختار نرم‌افزارهای پایدار و مقیاس‌پذیر.",
        "تضمین کیفیت و تست نرم‌افزار: طراحی برنامه‌های تست و تضمین کیفیت برای کاهش ریسک پروژه‌ها.",
        "مدیریت چرخه عمر نرم‌افزار: مشاوره در نگهداری، به‌روزرسانی و مدیریت طول عمر نرم‌افزارها."
      ]
    },
    {
      title: "سیستم",
      icon:<BsSquare size={"45px"}/>,
      description: "خدمات مشاوره‌ای ما در حوزه سیستم‌ها به بهبود کارایی و امنیت سیستم‌های سازمان کمک می‌کند.",
      items: [
        "بهینه‌سازی سیستم‌های سازمانی: تحلیل عملکرد و ارائه راهکار برای افزایش بهره‌وری.",
        "امنیت و پایداری سیستم‌ها: تدوین سیاست‌ها و برنامه‌های امنیتی برای کاهش خطرات عملیاتی.",
        "اتوماسیون و بهبود فرآیندها: طراحی سیستم‌های اتوماسیون برای ساده‌سازی فرآیندهای تکراری.",
        "مانیتورینگ و مدیریت عملکرد سیستم‌ها: راهکارهای نظارت و ارزیابی مستمر برای حفظ عملکرد مطلوب.",
        "مشاوره در پیاده‌سازی سیستم‌های جدید: انتخاب و استقرار سیستم‌های مناسب با نیازهای سازمان."
      ]
    },
    /*{
      title: "زیرساخت",
      icon:<GrServerCluster size={"45px"}/>,
      description: "مشاوره در حوزه زیرساخت‌ها کمک می‌کند تا سازمان‌ها محیطی امن، پایدار و مقیاس‌پذیر داشته باشند.",
      items: [
        "طراحی و بهینه‌سازی شبکه: تحلیل نیازها و ارائه راهکارهای شبکه امن و کارآمد.",
        "مدیریت سرورها و دیتاسنتر: مشاوره در استقرار، نگهداری و مانیتورینگ سرورها و دیتاسنتر.",
        "محاسبات ابری و Hybrid Cloud: طراحی و پیاده‌سازی راهکارهای ابری و ترکیبی.",
        "امنیت و دسترسی زیرساخت: تدوین استراتژی‌های امنیتی برای محافظت از منابع و داده‌ها.",
        "پایداری و Disaster Recovery: برنامه‌ریزی و مشاوره برای بازیابی سریع سیستم‌ها در شرایط اضطراری."
      ]
    }*/
  ];

  return (
    <div className="container my-5">
      {
        services.map(
            (item,index)=>{
                return(
                    <div key={index} className="row align-items-center">
                      <div className="col-md-4 p-2">
                        <h4 className="text-primary bold">
                          <span className="text-primary m-2"><BsCircleFill/></span>
                          {item.title}
                        </h4>
                        <br/>
                        <h5 className="bold text-muted" style={{lineHeight:"50px"}}>{item.description}</h5>
                      </div>
                      <div className="col-md-8 p-2">
                        <br/>
                        {
                            item.items.map(
                                (innerItem,index)=>{
                                    return(
                                        <p key={index} className="brand-p">
                                            <span className="m-2 text-primary"><BsCircle/></span>
                                            {innerItem}
                                        </p>
                                    )
                                }
                            )
                        }
                        
                      </div>
                      <hr/>
                       
                        
                    </div>
                )
            }
        )
      }
    </div>
  );
};

export default Solutions;
